/* PUNTA EN BLANCO — interacciones propias del tema (sin librerías externas) */
(function () {
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Aparición al hacer scroll ---------- */
  var observador = null;
  function initReveal(raiz) {
    var elementos = (raiz || document).querySelectorAll('.pb-reveal:not(.pb-visible)');
    if (!elementos.length) return;
    if (reducido || !('IntersectionObserver' in window)) {
      elementos.forEach(function (el) { el.classList.add('pb-visible'); });
      return;
    }
    if (!observador) {
      observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('pb-visible');
            observador.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    elementos.forEach(function (el) { observador.observe(el); });
  }

  /* ---------- Fechas de entrega ("recíbelo entre el 8 y el 14 de noviembre") ---------- */
  function sumarDias(base, dias) {
    var d = new Date(base.getTime());
    d.setDate(d.getDate() + dias);
    return d;
  }
  function textoRango(min, max) {
    var hoy = new Date();
    var a = sumarDias(hoy, min);
    var b = sumarDias(hoy, max);
    var mes = function (d) { return d.toLocaleDateString('es-ES', { month: 'long' }); };
    if (a.getMonth() === b.getMonth()) {
      return 'el ' + a.getDate() + ' y el ' + b.getDate() + ' de ' + mes(b);
    }
    return 'el ' + a.getDate() + ' de ' + mes(a) + ' y el ' + b.getDate() + ' de ' + mes(b);
  }
  function initEntrega(raiz) {
    (raiz || document).querySelectorAll('[data-pb-entrega]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 9;
      var max = parseInt(el.getAttribute('data-max'), 10) || 15;
      if (max < min) max = min;
      var destino = el.querySelector('[data-pb-fechas]');
      if (destino) destino.textContent = textoRango(min, max);
    });
  }

  /* ---------- Parallax suave en la apertura ---------- */
  var capas = [];
  var pendiente = false;
  function moverCapas() {
    pendiente = false;
    capas.forEach(function (c) {
      var r = c.seccion.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      c.capa.style.transform = 'translate3d(0,' + (-r.top * c.fuerza).toFixed(1) + 'px,0)';
    });
  }
  function initParallax() {
    capas = [];
    if (reducido || window.innerWidth < 750) return;
    document.querySelectorAll('[data-pb-parallax]').forEach(function (seccion) {
      var fuerza = parseInt(seccion.getAttribute('data-pb-parallax'), 10) || 0;
      var capa = seccion.querySelector('.pb-hero__parallax');
      if (!fuerza || !capa) return;
      capas.push({ seccion: seccion, capa: capa, fuerza: fuerza / 100 });
    });
    if (capas.length) moverCapas();
  }
  window.addEventListener('scroll', function () {
    if (!capas.length || pendiente) return;
    pendiente = true;
    window.requestAnimationFrame(moverCapas);
  }, { passive: true });

  /* ---------- Apertura con varias fotos que se funden (bloques "Foto" de pb-hero) ---------- */
  function initPortada(raiz) {
    (raiz || document).querySelectorAll('[data-pb-pases]').forEach(function (caja) {
      if (caja._ir) return;
      var pases = [].slice.call(caja.querySelectorAll('.pb-hero__pase'));
      var seccion = caja.closest('.pb-hero') || caja;
      var puntos = [].slice.call(seccion.querySelectorAll('[data-pb-punto]'));
      var ms = (parseFloat(caja.getAttribute('data-segundos')) || 6) * 1000;
      var actual = 0, temporizador = null;
      seccion.style.setProperty('--pb-pase-ms', ms + 'ms');
      function programar() {
        clearTimeout(temporizador);
        if (pases.length < 2 || reducido || document.hidden) return;
        temporizador = setTimeout(function () { ir(actual + 1); }, ms);
      }
      function ir(n) {
        var antes = pases[actual];
        actual = (n + pases.length) % pases.length;
        var ahora = pases[actual];
        if (antes !== ahora) {
          antes.classList.remove('is-activa');
          // El zoom vuelve a empezar cuando ya no se ve
          setTimeout(function () { if (!antes.classList.contains('is-activa')) antes.classList.remove('is-zoom'); }, 1800);
        }
        ahora.classList.remove('is-zoom');
        void ahora.offsetWidth;
        ahora.classList.add('is-activa');
        if (!reducido) ahora.classList.add('is-zoom');
        puntos.forEach(function (p, i) {
          p.classList.remove('is-activa');
          p.setAttribute('aria-current', i === actual ? 'true' : 'false');
          if (i === actual && !reducido) { void p.offsetWidth; p.classList.add('is-activa'); }
        });
        programar();
      }
      caja._ir = ir;
      puntos.forEach(function (p, i) { p.addEventListener('click', function () { ir(i); }); });
      document.addEventListener('visibilitychange', programar);
      ir(0);
    });
  }
  document.addEventListener('shopify:block:select', function (e) {
    var pase = e.target.closest && e.target.closest('.pb-hero__pase');
    var caja = pase && pase.closest('[data-pb-pases]');
    if (caja && caja._ir) caja._ir([].indexOf.call(caja.querySelectorAll('.pb-hero__pase'), pase));
  });

  /* ---------- Segunda foto al dejar el dedo sobre una tarjeta de producto ---------- */
  var toqueListo = false;
  function initToque() {
    if (toqueListo) return;
    toqueListo = true;
    var tarjeta = null, temporizador = null, x0 = 0, y0 = 0, inicio = 0;
    function soltar(e) {
      clearTimeout(temporizador);
      if (tarjeta) {
        var t = tarjeta;
        // Si ha dejado el dedo un rato (para ver la otra pose), no abrimos el producto al soltar
        if (e && e.type === 'touchend' && t.classList.contains('pb-toque') && Date.now() - inicio > 450 && e.cancelable) e.preventDefault();
        setTimeout(function () { t.classList.remove('pb-toque'); }, 350);
      }
      tarjeta = null;
    }
    document.addEventListener('touchstart', function (e) {
      var media = e.target.closest && e.target.closest('.card-wrapper .media--hover-effect');
      if (!media || media.querySelectorAll('img').length < 2) return;
      var t = e.touches[0];
      x0 = t.clientX; y0 = t.clientY; inicio = Date.now();
      tarjeta = media.closest('.card-wrapper');
      clearTimeout(temporizador);
      temporizador = setTimeout(function () { if (tarjeta) tarjeta.classList.add('pb-toque'); }, 120);
    }, { passive: true });
    document.addEventListener('touchmove', function (e) {
      if (!tarjeta) return;
      var t = e.touches[0];
      if (Math.abs(t.clientX - x0) > 12 || Math.abs(t.clientY - y0) > 12) { clearTimeout(temporizador); tarjeta.classList.remove('pb-toque'); tarjeta = null; }
    }, { passive: true });
    document.addEventListener('touchend', soltar, { passive: false });
    document.addEventListener('touchcancel', soltar, { passive: true });
  }

  /* ---------- Añadir a la cesta (tarjetas y sugerencias del carrito) ---------- */
  // Añade una variante y abre el carrito lateral de Dawn; en la página del carrito, la recarga.
  function anadir(id) {
    var cajon = document.querySelector('cart-drawer');
    var cuerpo = { id: id, quantity: 1 };
    if (cajon && cajon.getSectionsToRender) {
      cuerpo.sections = cajon.getSectionsToRender().map(function (s) { return s.id; });
      cuerpo.sections_url = window.location.pathname;
    }
    return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(cuerpo)
    }).then(function (r) {
      return r.json().then(function (datos) {
        if (!r.ok || datos.status) throw new Error(datos.description || datos.message || 'No se ha podido añadir');
        if (window.location.pathname.indexOf('/cart') === 0 || !cajon) { window.location.reload(); return datos; }
        cajon.classList.remove('is-empty');
        cajon.renderContents(datos);
        return datos;
      });
    });
  }

  /* Tarjeta: puntos de color, bolsa y panel de tallas (snippet pb-tarjeta-opciones) */
  function datosTarjeta(op) {
    if (!op._variantes) {
      try { op._variantes = JSON.parse(op.querySelector('[data-pb-variantes]').textContent); } catch (e) { op._variantes = []; }
    }
    return op._variantes;
  }
  function colorElegido(op) {
    var activo = op.querySelector('.pb-op__punto.is-activo');
    return activo ? activo.getAttribute('data-valor') : null;
  }
  function variantesDelColor(op) {
    var idx = parseInt(op.getAttribute('data-color'), 10);
    var color = colorElegido(op);
    return datosTarjeta(op).filter(function (v) { return idx < 0 || color === null || v.o[idx] === color; });
  }
  function avisar(op, texto) {
    var aviso = op.querySelector('.pb-op__aviso');
    if (!aviso) return;
    aviso.textContent = texto;
    aviso.hidden = false;
    setTimeout(function () { aviso.hidden = true; }, 2500);
  }
  function anadirDesdeTarjeta(op, variante, boton) {
    if (!variante || !variante.a) { avisar(op, 'Agotado'); return; }
    if (boton) boton.classList.add('is-cargando');
    anadir(variante.id).then(function () {
      var panel = op.querySelector('.pb-op__panel');
      if (panel) panel.hidden = true;
      op.classList.remove('is-abierto');
    }).catch(function (e) { avisar(op, e.message); }).then(function () {
      if (boton) boton.classList.remove('is-cargando');
    });
  }
  function initRapido() {
    if (document.documentElement.hasAttribute('data-pb-rapido')) return;
    document.documentElement.setAttribute('data-pb-rapido', '');
    document.addEventListener('click', function (e) {
      var op = e.target.closest && e.target.closest('[data-pb-op]');
      if (!op) return;
      var punto = e.target.closest('.pb-op__punto');
      var bolsa = e.target.closest('[data-pb-bolsa]');
      var talla = e.target.closest('.pb-op__talla');
      var cerrar = e.target.closest('[data-pb-cerrar]');
      if (!punto && !bolsa && !talla && !cerrar) return;
      e.preventDefault();
      e.stopPropagation();
      var panel = op.querySelector('.pb-op__panel');
      var elegir = parseInt(op.getAttribute('data-elegir'), 10);
      if (punto) {
        op.querySelectorAll('.pb-op__punto').forEach(function (p) { p.classList.toggle('is-activo', p === punto); });
        // Cambia la foto de la tarjeta por la de ese color
        var conFoto = variantesDelColor(op).filter(function (v) { return v.img; })[0];
        var tarjeta = op.closest('.card-wrapper');
        var foto = tarjeta && tarjeta.querySelector('.card__media img');
        if (conFoto && foto) {
          foto.removeAttribute('srcset');
          foto.src = conFoto.img;
          tarjeta.classList.add('pb-color-fijo');
        }
        if (panel && !panel.hidden) marcarTallas(op);
        return;
      }
      if (cerrar) { panel.hidden = true; op.classList.remove('is-abierto'); return; }
      if (bolsa) {
        if (elegir < 0 || !panel) {
          var lista = variantesDelColor(op);
          anadirDesdeTarjeta(op, lista.filter(function (v) { return v.a; })[0] || lista[0], bolsa);
          return;
        }
        marcarTallas(op);
        panel.hidden = !panel.hidden;
        op.classList.toggle('is-abierto', !panel.hidden);
        return;
      }
      if (talla) {
        var valor = talla.getAttribute('data-valor');
        var v = variantesDelColor(op).filter(function (x) { return x.o[elegir] === valor; });
        anadirDesdeTarjeta(op, v.filter(function (x) { return x.a; })[0] || v[0], talla);
      }
    });
    // Cerrar el panel de tallas al tocar fuera
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-pb-op]')) return;
      document.querySelectorAll('[data-pb-op].is-abierto').forEach(function (op) {
        op.classList.remove('is-abierto');
        var p = op.querySelector('.pb-op__panel');
        if (p) p.hidden = true;
      });
    });
  }
  function marcarTallas(op) {
    var elegir = parseInt(op.getAttribute('data-elegir'), 10);
    var lista = variantesDelColor(op);
    op.querySelectorAll('.pb-op__talla').forEach(function (b) {
      var hay = lista.some(function (v) { return v.o[elegir] === b.getAttribute('data-valor') && v.a; });
      b.disabled = !hay;
    });
  }

  /* Carrito: "Añade uno y el envío es gratis" (snippet pb-envio-carrito) */
  function initSugerencias() {
    if (document.documentElement.hasAttribute('data-pb-sugerencias')) return;
    document.documentElement.setAttribute('data-pb-sugerencias', '');
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-pb-add]');
      if (!b) return;
      e.preventDefault();
      b.disabled = true;
      b.textContent = 'Añadiendo…';
      anadir(parseInt(b.getAttribute('data-pb-add'), 10)).catch(function () {
        b.disabled = false;
        b.textContent = 'Añadir';
      });
    });
  }

  /* ---------- Ventana de bienvenida: rasca y gana un 10 % por suscribirse (snippet pb-bienvenida) ---------- */
  var CLAVE_BIENVENIDA = 'pb-bienvenida';
  function leerMemoria() { try { return JSON.parse(window.localStorage.getItem(CLAVE_BIENVENIDA) || '{}'); } catch (e) { return {}; } }
  function guardarMemoria(d) { try { window.localStorage.setItem(CLAVE_BIENVENIDA, JSON.stringify(d)); } catch (e) {} }

  // Tarjeta dorada que se rasca con el dedo o el ratón; al quitar casi la mitad se descubre entera
  function initRasca(v, alDescubrir) {
    var caja = v.querySelector('[data-pb-rasca]');
    var lienzo = caja && caja.querySelector('[data-pb-rasca-capa]');
    if (!lienzo || !lienzo.getContext) return { pintar: function () {} };
    var ctx = lienzo.getContext('2d', { willReadFrequently: true });
    var hecho = false, pintado = false, rascando = false, ultimo = null, trazos = 0;
    function pintar() {
      if (pintado || hecho) return;
      var r = caja.getBoundingClientRect();
      if (!r.width) return;
      pintado = true;
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var w = r.width, h = r.height;
      lienzo.width = Math.round(w * dpr);
      lienzo.height = Math.round(h * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var oro = ctx.createLinearGradient(0, 0, w, h);
      oro.addColorStop(0, '#A8874E');
      oro.addColorStop(0.42, '#D9BF88');
      oro.addColorStop(0.5, '#EBD9B0');
      oro.addColorStop(0.58, '#D2B57B');
      oro.addColorStop(1, '#9C7B43');
      ctx.fillStyle = oro;
      ctx.fillRect(0, 0, w, h);
      // Grano fino para que parezca papel metalizado
      for (var i = 0; i < (w * h) / 14; i++) {
        ctx.fillStyle = Math.random() < 0.5 ? 'rgba(255,255,255,0.09)' : 'rgba(60,40,10,0.07)';
        ctx.fillRect(Math.random() * w, Math.random() * h, 1, 1);
      }
      ctx.strokeStyle = 'rgba(250,247,242,0.75)';
      ctx.lineWidth = 1;
      ctx.strokeRect(9.5, 9.5, w - 19, h - 19);
      ctx.fillStyle = '#FAF7F2';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      if ('letterSpacing' in ctx) ctx.letterSpacing = '3px';
      ctx.font = '500 10px ' + getComputedStyle(document.body).fontFamily;
      ctx.fillText('PUNTA EN BLANCO', w / 2, 28);
      ctx.fillText('PARA DESCUBRIR TU REGALO', w / 2, h - 27);
      if ('letterSpacing' in ctx) ctx.letterSpacing = '0px';
      ctx.font = 'italic 500 ' + Math.round(h * 0.25) + 'px "Cormorant Garamond", Georgia, serif';
      ctx.fillText('Rasca aquí', w / 2, h / 2 + 2);
      // Hasta aquí el dorado lo ponía el CSS; ahora lo que se rasca deja ver el premio
      lienzo.classList.add('is-pintado');
    }
    function punto(e) {
      var r = lienzo.getBoundingClientRect();
      return { x: e.clientX - r.left, y: e.clientY - r.top };
    }
    function rascar(e) {
      var p = punto(e);
      ctx.globalCompositeOperation = 'destination-out';
      ctx.lineWidth = 36;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.beginPath();
      if (ultimo) { ctx.moveTo(ultimo.x, ultimo.y); ctx.lineTo(p.x, p.y); ctx.stroke(); }
      else { ctx.arc(p.x, p.y, 18, 0, Math.PI * 2); ctx.fill(); }
      ctx.globalCompositeOperation = 'source-over';
      ultimo = p;
      if (++trazos % 6 === 0) comprobar();
    }
    function comprobar() {
      if (hecho || !lienzo.width) return;
      var datos = ctx.getImageData(0, 0, lienzo.width, lienzo.height).data;
      var vacios = 0, total = 0;
      for (var i = 3; i < datos.length; i += 64) { total++; if (datos[i] < 128) vacios++; }
      if (vacios / total > 0.45) descubrir();
    }
    function descubrir() {
      if (hecho) return;
      hecho = true;
      caja.classList.add('is-descubierto');
      alDescubrir();
    }
    lienzo.addEventListener('pointerdown', function (e) {
      if (hecho) return;
      pintar();
      rascando = true;
      ultimo = null;
      if (lienzo.setPointerCapture) lienzo.setPointerCapture(e.pointerId);
      rascar(e);
    });
    lienzo.addEventListener('pointermove', function (e) { if (rascando && !hecho) rascar(e); });
    ['pointerup', 'pointercancel'].forEach(function (t) {
      lienzo.addEventListener(t, function () { rascando = false; ultimo = null; comprobar(); });
    });
    lienzo.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); descubrir(); }
    });
    return {
      pintar: function () {
        // Espera a la letra de la marca para escribir "Rasca aquí" con ella
        if (document.fonts && document.fonts.load) {
          document.fonts.load('italic 500 40px "Cormorant Garamond"').then(pintar, pintar);
        } else pintar();
      }
    };
  }

  function initBienvenida() {
    var v = document.querySelector('[data-pb-bienvenida]');
    if (!v || v._listo) return;
    v._listo = true;
    // Pestaña fija en el lateral: siempre a mano mientras la ventana está cerrada y no se ha suscrito
    var pestana = document.querySelector('[data-pb-pestana]');
    function verPestana(si) { if (pestana) pestana.hidden = !si || !!leerMemoria().suscrita; }
    if (pestana) pestana.addEventListener('click', function () { abrir(); });
    var paso1 = v.querySelector('[data-pb-paso="1"]');
    var paso2 = v.querySelector('[data-pb-paso="2"]');
    var reclamar = v.querySelector('[data-pb-reclamar]');
    function irAlCorreo() {
      if (!paso1 || !paso2) return;
      paso1.hidden = true;
      paso2.hidden = false;
      var campo = paso2.querySelector('input[type="email"]');
      if (campo) campo.focus();
    }
    var rasca = initRasca(v, function () {
      var m = leerMemoria();
      m.rascada = true;
      guardarMemoria(m);
      if (reclamar) { reclamar.hidden = false; reclamar.focus(); }
    });
    if (reclamar) reclamar.addEventListener('click', irAlCorreo);
    function abrir() {
      if (!v.hidden) return;
      v.hidden = false;
      verPestana(false);
      document.body.classList.add('pb-bienvenida-abierta');
      // Si ya rascó otro día, directa al paso del correo
      if (leerMemoria().rascada && paso1 && !paso1.hidden) { paso1.hidden = true; if (paso2) paso2.hidden = false; }
      if (paso1 && !paso1.hidden) rasca.pintar();
      var campo = v.querySelector('input[type="email"]');
      if (campo && paso2 && !paso2.hidden && window.innerWidth > 749) campo.focus();
    }
    function cerrar() {
      v.hidden = true;
      document.body.classList.remove('pb-bienvenida-abierta');
      var m = leerMemoria();
      if (!m.suscrita) { m.cerrada = Date.now(); guardarMemoria(m); }
      verPestana(true);
    }
    verPestana(true);
    v.querySelectorAll('[data-pb-cerrar-bienvenida]').forEach(function (b) { b.addEventListener('click', cerrar); });
    v.addEventListener('click', function (e) { if (e.target === v) cerrar(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !v.hidden) cerrar(); });
    document.addEventListener('click', function (e) {
      var enlace = e.target.closest && e.target.closest('a[href$="#bienvenida"]');
      if (enlace) { e.preventDefault(); abrir(); }
    });
    var copiar = v.querySelector('[data-pb-copiar]');
    if (copiar) copiar.addEventListener('click', function () {
      var codigo = copiar.getAttribute('data-pb-copiar');
      var hecho = function () { copiar.textContent = 'Código copiado'; };
      if (navigator.clipboard) navigator.clipboard.writeText(codigo).then(hecho, hecho); else hecho();
    });
    // Tras enviar el formulario la página vuelve con el resultado: se abre sola para enseñar el código o el error
    var estado = v.getAttribute('data-estado');
    if (estado === 'ok') { guardarMemoria({ suscrita: true }); abrir(); return; }
    if (estado === 'error' || window.location.hash === '#bienvenida') { abrir(); return; }
    var m = leerMemoria();
    if (m.suscrita || (m.cerrada && Date.now() - m.cerrada < 7 * 24 * 3600 * 1000)) return;
    var temporizador = setTimeout(abrir, 9000);
    var alBajar = function () {
      if (window.scrollY > document.documentElement.scrollHeight * 0.35) {
        clearTimeout(temporizador);
        window.removeEventListener('scroll', alBajar);
        abrir();
      }
    };
    window.addEventListener('scroll', alBajar, { passive: true });
  }

  /* ---------- Lista de deseos (snippets pb-corazon y sección pb-deseos) ---------- */
  // Se guarda en el navegador (lista de handles). Con servidor y sesión iniciada, también en la cuenta de la clienta:
  // al entrar se junta la del navegador con la de la cuenta, y cada cambio se manda al servidor.
  var CLAVE_DESEOS = 'pb-deseos';
  var datosDeseos = null;
  var pedidoPagina = 0;
  function leerDeseos() {
    try { var l = JSON.parse(window.localStorage.getItem(CLAVE_DESEOS) || '[]'); return Array.isArray(l) ? l : []; } catch (e) { return []; }
  }
  function guardarDeseos(l) { try { window.localStorage.setItem(CLAVE_DESEOS, JSON.stringify(l)); } catch (e) {} }
  function configDeseos() {
    if (!datosDeseos) {
      try { datosDeseos = JSON.parse(document.getElementById('pb-deseos-datos').textContent); } catch (e) { datosDeseos = {}; }
    }
    return datosDeseos;
  }
  function servidorDeseos(lista, reemplazar) {
    var c = configDeseos();
    if (!c.servidor || !c.cliente || !c.firma) return Promise.resolve(null);
    return fetch(c.servidor, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' },
      body: JSON.stringify({ accion: 'deseos', cliente: String(c.cliente), firma: c.firma, lista: lista, reemplazar: !!reemplazar })
    }).then(function (r) { return r.json(); })
      .then(function (d) { return d && Array.isArray(d.lista) ? d.lista : null; })
      .catch(function () { return null; });
  }
  function textoSeguro(t) { var d = document.createElement('div'); d.textContent = t || ''; return d.innerHTML; }
  function pintarCorazones(raiz) {
    var lista = leerDeseos();
    (raiz || document).querySelectorAll('[data-pb-deseo]').forEach(function (b) {
      var si = lista.indexOf(b.getAttribute('data-pb-deseo')) > -1;
      b.classList.toggle('is-guardado', si);
      b.setAttribute('aria-pressed', si ? 'true' : 'false');
      var t = b.querySelector('[data-pb-deseo-texto]');
      if (t) t.textContent = si ? 'Guardado en mi lista' : 'Guardar en mi lista';
    });
    document.querySelectorAll('[data-pb-deseos-cuenta]').forEach(function (c) {
      c.textContent = lista.length;
      c.hidden = !lista.length;
    });
  }
  function pintarPaginaDeseos(p) {
    var rejilla = p.querySelector('[data-pb-deseos-rejilla]');
    var vacia = p.querySelector('[data-pb-deseos-vacia]');
    var lista = leerDeseos();
    var pedido = ++pedidoPagina;
    if (!lista.length) { rejilla.innerHTML = ''; vacia.hidden = false; return; }
    var corazon = (document.querySelector('.header__icon--deseos svg') || {}).outerHTML || '';
    Promise.all(lista.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (productos) {
      if (pedido !== pedidoPagina) return;
      rejilla.innerHTML = '';
      productos.forEach(function (pr) {
        if (!pr) return; // producto archivado o borrado
        var foto = pr.featured_image ? pr.featured_image + (pr.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=600' : '';
        var precio = (pr.price / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
        var a = document.createElement('article');
        a.className = 'pb-deseo';
        a.innerHTML =
          '<a class="pb-deseo__foto" href="' + pr.url + '">' + (foto ? '<img src="' + foto + '" alt="" loading="lazy">' : '') + '</a>' +
          '<button type="button" class="pb-corazon is-guardado" data-pb-deseo="' + textoSeguro(pr.handle) + '" aria-pressed="true" aria-label="Quitar ' + textoSeguro(pr.title) + ' de mi lista">' + corazon + '</button>' +
          '<div class="pb-deseo__info"><a class="pb-deseo__nombre" href="' + pr.url + '">' + textoSeguro(pr.title) + '</a>' +
          '<p class="pb-deseo__precio">' + precio + '</p>' +
          '<a class="pb-deseo__ver" href="' + pr.url + '">' + (pr.available ? 'Elegir talla y color' : 'Agotado') + '</a></div>';
        rejilla.appendChild(a);
      });
      vacia.hidden = rejilla.children.length > 0;
    });
  }
  function initDeseos(raiz) {
    if (!document.getElementById('pb-deseos-datos')) return;
    pintarCorazones(raiz);
    if (document.documentElement.hasAttribute('data-pb-deseos')) return;
    document.documentElement.setAttribute('data-pb-deseos', '');
    var pagina = document.querySelector('[data-pb-deseos-pagina]');
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-pb-deseo]');
      if (!b) return;
      e.preventDefault();
      e.stopPropagation();
      var h = b.getAttribute('data-pb-deseo');
      var lista = leerDeseos();
      var i = lista.indexOf(h);
      if (i > -1) lista.splice(i, 1); else lista.unshift(h);
      guardarDeseos(lista);
      pintarCorazones();
      if (i < 0) {
        b.classList.add('is-latido');
        setTimeout(function () { b.classList.remove('is-latido'); }, 700);
      }
      if (pagina && i > -1) pintarPaginaDeseos(pagina);
      servidorDeseos(lista, true);
    });
    // Otra pestaña abierta de la tienda cambió la lista
    window.addEventListener('storage', function (e) { if (e.key === CLAVE_DESEOS) pintarCorazones(); });
    if (pagina) pintarPaginaDeseos(pagina);
    servidorDeseos(leerDeseos(), false).then(function (l) {
      if (!l) return;
      guardarDeseos(l);
      pintarCorazones();
      if (pagina) pintarPaginaDeseos(pagina);
    });
  }

  /* ---------- Asistente de ayuda (snippet pb-asistente) ---------- */
  // Busca la pregunta frecuente que más se parece a lo que escribe la clienta. Las palabras de cada grupo cuentan
  // como la misma idea ("tarda", "llega", "plazo"...), así entiende preguntas escritas de muchas formas.
  var IDEAS = [
    ['plazo', 'tarda', 'tardan', 'tardais', 'llega', 'llegan', 'llegara', 'llegar', 'cuando', 'dias', 'plazo', 'plazos', 'recibo', 'recibir', 'recibire', 'entrega', 'entregan', 'rapido', 'urgente', 'boda', 'evento', 'fecha', 'tiempo'],
    ['envio', 'envio', 'envios', 'enviar', 'enviais', 'mandais', 'portes', 'gastos', 'gratis', 'gratuito', 'coste', 'cuesta', 'precio', 'transporte', 'mensajero'],
    ['talla', 'talla', 'tallas', 'tallaje', 'medida', 'medidas', 'mido', 'peso', 'peso', 'queda', 'quedara', 'pequeno', 'grande', 'ajustado', 'xs', 's', 'm', 'l', 'xl', 'guia'],
    ['devolver', 'devolver', 'devolucion', 'devoluciones', 'devuelvo', 'cambiar', 'cambio', 'cambios', 'desistimiento', 'gusta', 'convence'],
    ['dinero', 'dinero', 'reembolso', 'reembolsar', 'devolveis', 'abonais', 'abono', 'cobrado'],
    ['pago', 'pagar', 'pago', 'pagos', 'tarjeta', 'paypal', 'bizum', 'transferencia', 'metodo', 'metodos', 'klarna', 'apple', 'google', 'seguro', 'cuotas'],
    ['contacto', 'contacto', 'contactar', 'email', 'correo', 'telefono', 'llamar', 'whatsapp', 'hablar', 'persona', 'atencion', 'escribir'],
    ['seguimiento', 'seguimiento', 'donde', 'localizar', 'rastrear', 'tracking', 'numero', 'llegado', 'estado', 'camino'],
    ['problema', 'roto', 'rota', 'danado', 'danada', 'defectuoso', 'defecto', 'equivocado', 'equivocada', 'incorrecto', 'falta', 'perdido', 'mal', 'manchado'],
    ['cancelar', 'cancelar', 'anular', 'modificar', 'direccion', 'error', 'equivoque'],
    ['extranjero', 'fuera', 'extranjero', 'internacional', 'portugal', 'francia', 'italia', 'europa', 'andorra', 'paises', 'mundo'],
    ['descuento', 'descuento', 'descuentos', 'codigo', 'cupon', 'oferta', 'ofertas', 'rebaja', 'rebajas', 'regalo', 'bienvenida', 'promocion', 'primera'],
    ['pedido', 'pedido', 'pedidos', 'compra', 'orden']
  ];
  var VACIAS = ' a al algo con de del el en es esta este hay la las le lo los me mi mis no o para pero por que se si su te tengo tu un una y ya yo como puedo quiero hola gracias favor buenas buenos dias tardes noches vosotros vuestro vuestra os '.split(' ');
  function normalizar(t) {
    return (t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9ñ ]+/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function ideas(texto) {
    var palabras = normalizar(texto).split(' ').filter(function (p) { return p && VACIAS.indexOf(p) < 0; });
    var res = {};
    palabras.forEach(function (p) {
      var encontrada = false;
      IDEAS.forEach(function (grupo) {
        if (grupo.indexOf(p, 1) > 0 || (p.length > 4 && grupo.some(function (g, i) { return i > 0 && g.length > 4 && (g.indexOf(p) === 0 || p.indexOf(g) === 0); }))) {
          res['#' + grupo[0]] = 1;
          encontrada = true;
        }
      });
      if (!encontrada && p.length > 3) res[p] = 1;
    });
    return res;
  }
  function initAsistente() {
    var caja = document.querySelector('[data-pb-asistente]');
    var datosEl = document.getElementById('pb-asistente-datos');
    if (!caja || caja._listo || !datosEl) return;
    caja._listo = true;
    var datos = {};
    try { datos = JSON.parse(datosEl.textContent); } catch (e) { datos = { preguntas: [] }; }
    var preguntas = (datos.preguntas || []).map(function (q) { return { p: q.p, r: q.r, ideasP: ideas(q.p), ideasR: ideas(q.r.replace(/<[^>]+>/g, ' ')) }; });
    var boton = caja.querySelector('[data-pb-asistente-boton]');
    var panel = caja.querySelector('.pb-asistente__panel');
    var mensajes = caja.querySelector('[data-pb-asistente-mensajes]');
    var atajos = caja.querySelector('[data-pb-asistente-atajos]');
    var form = caja.querySelector('[data-pb-asistente-form]');
    var campo = form.querySelector('input');
    var historial = [];
    var correo = datos.correo || '';
    function escapar(t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; }
    function decir(html, quien) {
      var m = document.createElement('div');
      m.className = 'pb-asistente__msg pb-asistente__msg--' + quien;
      m.innerHTML = html;
      mensajes.appendChild(m);
      // Las respuestas largas se ven desde el principio
      mensajes.scrollTop = quien === 'tienda' ? m.offsetTop - mensajes.offsetTop - 8 : mensajes.scrollHeight;
      return m;
    }
    function ponerAtajos(lista) {
      atajos.innerHTML = '';
      lista.forEach(function (q) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pb-asistente__atajo';
        b.textContent = q.p;
        b.addEventListener('click', function () { preguntar(q.p, q); });
        atajos.appendChild(b);
      });
    }
    function mejores(texto) {
      var mias = ideas(texto);
      var claves = Object.keys(mias);
      return preguntas.map(function (q) {
        var puntos = 0;
        claves.forEach(function (k) {
          if (q.ideasP[k]) puntos += k.charAt(0) === '#' ? 3 : 2;
          else if (q.ideasR[k]) puntos += 1;
        });
        return { q: q, puntos: puntos };
      }).filter(function (x) { return x.puntos > 0; }).sort(function (a, b) { return b.puntos - a.puntos; });
    }
    function sinRespuesta(texto) {
      var correoHtml = '<a href="mailto:' + correo + '">' + correo + '</a>';
      // Pocas palabras suele ser una prenda ("vestido verde"): primero la búsqueda en la tienda
      if (normalizar(texto).split(' ').length <= 4) {
        decir('<p>Mira lo que tenemos de <a href="/search?q=' + encodeURIComponent(texto) + '">«' + escapar(texto) + '»</a>.</p>' +
          '<p>Si lo que tienes es una duda, escríbenos a ' + correoHtml + ' y te respondemos en menos de 24 horas.</p>', 'tienda');
        return;
      }
      decir('<p>Esa no la sé todavía. Escríbenos a ' + correoHtml + ' y te respondemos en menos de 24 horas, de lunes a viernes.</p>', 'tienda');
    }
    function responderLocal(texto, elegida) {
      var lista = elegida ? [{ q: elegida, puntos: 9 }] : mejores(texto);
      if (!lista.length || lista[0].puntos < 3) { sinRespuesta(texto); ponerAtajos(preguntas.slice(0, 4)); return; }
      decir(lista[0].q.r, 'tienda');
      var otras = lista.slice(1, 3).map(function (x) { return x.q; });
      ponerAtajos(otras.length ? otras : preguntas.filter(function (q) { return q !== lista[0].q; }).slice(0, 3));
    }
    function preguntar(texto, elegida) {
      texto = (texto || '').trim();
      if (!texto) return;
      decir('<p>' + escapar(texto) + '</p>', 'clienta');
      historial.push({ rol: 'clienta', texto: texto });
      atajos.innerHTML = '';
      // Con servidor de IA configurado, pregunta a la IA; si falla, contesta con las preguntas frecuentes
      if (datos.ia && !elegida) {
        var escribiendo = decir('<p class="pb-asistente__puntos"><span></span><span></span><span></span></p>', 'tienda');
        fetch(datos.ia, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain' },
          body: JSON.stringify({
            pregunta: texto,
            historial: historial.slice(-6),
            pagina: location.pathname,
            contexto: preguntas.map(function (q) { return q.p + '\n' + q.r.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim(); }).join('\n\n')
          })
        }).then(function (r) { return r.json(); }).then(function (d) {
          escribiendo.remove();
          if (!d || !d.respuesta) throw new Error('sin respuesta');
          decir('<p>' + escapar(d.respuesta).replace(/\n/g, '<br>') + '</p>', 'tienda');
          historial.push({ rol: 'tienda', texto: d.respuesta });
        }).catch(function () { escribiendo.remove(); responderLocal(texto); });
        return;
      }
      setTimeout(function () { responderLocal(texto, elegida); }, 250);
    }
    function abrir() {
      panel.hidden = false;
      boton.setAttribute('aria-expanded', 'true');
      caja.classList.add('is-abierto');
      if (!mensajes.children.length) {
        decir('<p>¡Hola! Soy el asistente de Punta en Blanco. Pregúntame lo que quieras sobre envíos, tallas, devoluciones o pagos.</p>', 'tienda');
        ponerAtajos(preguntas.slice(0, 4));
      }
      if (window.innerWidth > 749) campo.focus();
    }
    function cerrar() {
      panel.hidden = true;
      boton.setAttribute('aria-expanded', 'false');
      caja.classList.remove('is-abierto');
    }
    boton.addEventListener('click', function () { if (panel.hidden) abrir(); else cerrar(); });
    caja.querySelector('[data-pb-asistente-cerrar]').addEventListener('click', function () { cerrar(); boton.focus(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) { cerrar(); boton.focus(); } });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-pb-abrir-asistente]')) { e.preventDefault(); abrir(); }
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var t = campo.value;
      campo.value = '';
      preguntar(t);
    });
  }

  /* ---------- Menú de la cabecera: los subapartados se abren al pasar el ratón (como en florenceparis.com) ---------- */
  function initMenuHover() {
    if (document.documentElement.hasAttribute('data-pb-menu-hover') || !window.matchMedia('(hover: hover)').matches) return;
    document.documentElement.setAttribute('data-pb-menu-hover', '');
    document.querySelectorAll('.header__inline-menu details').forEach(function (d) {
      var li = d.closest('li') || d;
      var cierre = null;
      li.addEventListener('mouseenter', function () {
        clearTimeout(cierre);
        document.querySelectorAll('.header__inline-menu details[open]').forEach(function (o) { if (o !== d) o.removeAttribute('open'); });
        d.setAttribute('open', '');
        var s = d.querySelector('summary');
        if (s) s.setAttribute('aria-expanded', 'true');
      });
      li.addEventListener('mouseleave', function () {
        cierre = setTimeout(function () {
          d.removeAttribute('open');
          var s = d.querySelector('summary');
          if (s) s.setAttribute('aria-expanded', 'false');
        }, 180);
      });
    });
  }

  function initTodo(raiz) {
    initReveal(raiz);
    initEntrega(raiz);
    initParallax();
    initPortada(raiz);
    initToque();
    initRapido();
    initSugerencias();
    initBienvenida();
    initAsistente();
    initDeseos(raiz);
    initMenuHover();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initTodo(); });
  } else {
    initTodo();
  }

  /* Editor de Shopify: volver a activar al añadir o cambiar una sección */
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
})();
